// Shared by the settings dialog and definition editors. Preserve legacy schema encodings.
export const definitionKeys = [
  'formDefintion', 'formDefinition', 'formCustomizingDefintion', 'formCustomizingDefinition',
  'formAfterDefintion', 'definition', 'formCustomizings', 'formBPM'
];

function canonical(value) {
  if (value == null) return null;
  if (Array.isArray(value)) return value.map(canonical);
  if (typeof value === 'object') return Object.keys(value).sort().reduce((result, key) => {
    result[key] = canonical(value[key]); return result;
  }, {});
  return value;
}
function definitionValue(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'string' && value.trim()) {
    try { return JSON.parse(value); } catch (_) { return value; }
  }
  return value;
}
export function definitionChanges(item, original, versions) {
  return definitionKeys.filter(key =>
    JSON.stringify(canonical(definitionValue(item[key]))) !==
    JSON.stringify(canonical(definitionValue(original[key])))
  ).map(name => ({ name, value: item[name] == null ? null : item[name], version: versions[name] }));
}
export function settingsRequest(baseData) {
  const metadata = {};
  Object.keys(baseData.item).forEach(key => {
    if (!definitionKeys.includes(key) && !['formId', 'collectionValueId', 'OrgSaveFunction'].includes(key)) {
      metadata[key] = baseData.item[key];
    }
  });
  const input = {
    metadata,
    rowVersion: baseData.formMetadata.rowVersion,
    settings: {
      hidden: baseData.hidden == null ? null : baseData.hidden,
      showFrom: baseData.showFrom || null,
      showUntil: baseData.showUntil || null,
      restrictionGroups: baseData.restrictionGroups && baseData.restrictionGroups.length
        ? JSON.stringify(baseData.restrictionGroups.map(g => ({ adGroupId: g.adGroupId, adGroupName: g.adGroupName })))
        : null
    }
  };
  const definitions = definitionChanges(baseData.item, baseData.formMetadata.definitions, baseData.formMetadata.versions);
  return definitions.length ? { endpoint: 'settings', body: { metadata: input, definitions } }
    : { endpoint: 'metadata', body: input };
}
export function formSaveError(error) {
  return error.response && error.response.status === 409
    ? 'Das Formular wurde inzwischen geÃ¤ndert. Bitte den Dialog neu Ã¶ffnen. Ihre Ã„nderungen wurden nicht gespeichert.'
    : (error.response && error.response.data && error.response.data.message) || 'Die Ã„nderungen konnten nicht gespeichert werden.';
}
